import { keyBy } from "lodash";

import { CRUDAction, IEntityFetchSuccess, RequestAction } from "../actions";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "../reducer";

import { SUBSCRIPTION, SubscriptionAction } from "./actions";
import { IFetchCollectionSuccessPayload, ISubscription } from "./interfaces";

const initialState = {};

export const subscriptionsReducer = (
  state: IEntityCollectionState<ISubscription> = initialState,
  action: SubscriptionAction
): IEntityCollectionState<ISubscription> => {
  switch (action.type) {
    case SUBSCRIPTION[CRUDAction.CREATE][RequestAction.SUCCESS]:
    case SUBSCRIPTION[CRUDAction.UPDATE][RequestAction.SUCCESS]: {
      const { value: subscription } = action.payload as IEntityFetchSuccess<ISubscription>;
      return {
        ...state,
        [subscription.id]: subscription,
      };
    }

    case SUBSCRIPTION[CRUDAction.FETCH_COLLECTION][RequestAction.SUCCESS]: {
      const { values } = action.payload as IFetchCollectionSuccessPayload;
      return keyBy(values, v => v.id);
    }

    default:
      return state;
  }
};
